import { render } from "./designTextarea.vue?vue&type=template&id=237a18e2"
import script from "./designTextarea.vue?vue&type=script&lang=js"
export * from "./designTextarea.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__